import { liveItems, type ListKind, type ListVisibility } from "@home/shared";
import { todayIso } from "./format.ts";
import { newId } from "./sync/engine.ts";
import { engine } from "./store.ts";

export async function createList(name: string, kind: ListKind, visibility: ListVisibility, isTemplate: boolean): Promise<string> {
  const id = newId();
  await engine.mutate({ type: "list.create", id, name, kind, visibility, isTemplate });
  return id;
}

/** Копия списка с новыми id позиций — работает и офлайн. */
export async function copyList(sourceId: string, name: string, isTemplate: boolean): Promise<string> {
  const id = newId();
  const items = liveItems(engine.getView().state, sourceId);
  const itemIds = Object.fromEntries(items.map((i) => [i.id, newId()]));
  await engine.mutate({ type: "list.copy", id, sourceId, name, isTemplate, itemIds });
  return id;
}

/** «03.10» для названия нового списка — по Ташкенту, как даты операций. */
export function todayLabel(): string {
  const d = todayIso();
  return `${d.slice(8, 10)}.${d.slice(5, 7)}`;
}
